<template>
	<div class="inner-page add-distributor">
		<AppHead title="Create new distributor" />

		<PageHeader 
			title="Add Distributor"
			desc="Add a new distributor to the Document Room"
			:hasButton="false"
			:showHelper="true"
			helpTitle="Adding a new distributor"
			helpDesc="Give your new distributor a name and then on the User Management screen you will be able to assign users to it."
			:hr="true"
			/>

		<InputGroup
			title="New Distributor Details"
			desc="Please fill in all fields to create a new distributor."
			>

			<ValidationErrors />
			
			<InputText
				label="Distributor Name"
				type="text"
				v-model="form.name"
				autocomplete="disabled"
				/>

		</InputGroup>

		<InputGroup
			title=""
			desc=""
			:skipWhiteBox="true"
			:noLine="true"
			>
			<Button
				label="Create"
				color="green"
				size="regular"
				icon="plus" 
				@click="submit"
				/>
		</InputGroup>

	</div>
</template>

<script>
import AppHead from "@/Components/AppHead"
import AppLayout from "@/Layouts/AppLayout.vue"
import PageHeader from "@/Components/PageHeader"
import InputGroup from "@/Components/InputGroup"
import InputText from "@/Components/InputText"
import InputFancyRadio from "@/Components/InputFancyRadio"
import Button from "@/Components/Button"
import ValidationErrors from "@/Components/ValidationErrors"

export default {
	components: {
		AppHead,
		PageHeader,
		InputGroup,
		InputText,
		InputFancyRadio,
		ValidationErrors,
		Button
	},
	layout: AppLayout,
	data: () => {
		return {
			form: {
				name: null
			}
		}
	},
	methods: {
		submit(){
			let count = 0
			for(let field in this.form){
				let thisField = this.form[field]
				if(thisField == null || thisField == ''){
					break
				}
				count++
			}

			if(Object.keys(this.form).length == count){
				this.$inertia.post('/admin/team/new', {
					name: this.form.name,
				})
			}else{
				alert(`Please complete all fields`)
			}
		}
	}
};
</script>

<style lang="sass" scoped>

// .add-team

</style>